import { Button } from '@mui/material';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Image1HomeExpert from '../../../src/Assets/homePage/Imgae1HomeESN.png';
import { buttonStylesBlue, buttonStylesGreen } from '../../Components/docsAdministrative/JsObjectStyles';
import Footer from '../../Components/shared/Footer/Footer';
import NavbarHome from '../../Components/shared/Navbar/NavbarHome';
import {DrawImageHomeEsn232, DrawImageHomeEsn2321,DrawImageHomeExpert21, DrawImageHomeExpert22, DrawImageHomeExpert23, DrawImageHomeExpert24, DrawImageHomeExpert25, DrawImageHomeExpert26 } from '../../data/SVGs';
import {IconBox1container, IconBox2container, IconBox3container, IconBox4container, IconBox5container, IconBox6container, IconBox7container, IconBox8container, IconBox9container} from '../../data/SVGs';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import useWindowSize from '../../hooks/useWindowSize';

function HomeESN() {

    const navigate=useNavigate();
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    usePersistedLanguage();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes
    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignSelf:'stretch',background:'white',height:'fit-content',width:'100%'}}>
                <NavbarHome />
                <div style={{display:'flex',flexDirection:'column',gap:'65px',alignItems:'center',alignSelf:'stretch'}}>
                    <div
                        className='frame105HomePage'
                        id='expert'
                        style={{width:'90%'}}
                    >
                        <div
                            className='frame106HomePage'
                            style={{marginTop:device=='desktop'?'90px':'30px'}}
                        >
                            <div className='frame107HomePage'>
                                <div className='frame108HomePage'>
                                    <h3 className='frame101HomePage'>
                                        {i18n.t('Une solution sur mesure pour développer votre activité')}
                                    </h3>
                                    {device!='desktop' &&
                                    <div className='frame112HomePage'>
                                        <img src={Image1HomeExpert} />
                                    </div>
                                    }
                                    <h6 className='frame110HomePage'>
                                        {i18n.t('High Tech Hires vous offre l\'opportunité de trouver des experts pour vos projets tout en vous permettant de gérer efficacement vos ressources externes.')}                                   </h6>
                                </div>
                                <div className='frame111HomePage'>
                                    <div className="frame0HomePage">
                                        <Button
                                            variant="contained"
                                            style={{...buttonStylesBlue(false),...{
                                                height: '48px',width:device=='desktop'?'auto':'100%'}}}
                                            onClick={()=>{navigate('/register');}}
                                        > {i18n.t('Nous Rejoindre')}
                                        </Button></div>

                                </div>
                            </div>
                            {device=='desktop' &&
                            <div className='frame112HomePage'>
                                <img src={Image1HomeExpert} />
                            </div>
                            }

                        </div>
                    </div>

                    <div className="homeExpertf27 homeExpertf30">
                        <div className="homeExpertf28">
                            <h5 className='homeExpertf16 homeExpertf31B'>
                                {i18n.t('Nous vous offrons')}
                            </h5>
                            <h3 className='frame101HomePage'>
                                {i18n.t('Bien plus qu\'une simple plateforme de Sourcing!')}
                            </h3>
                        </div>
                        <div className="homeExpertf32">
                            <div className="homeExpertf33">
                                <DrawImageHomeEsn232
                                    width={device=='desktop'?'446':'300'}
                                    height={device=='desktop'?'347':'100%'}
                                />
                                <div className='homeExpertf34' >
                                    <h5 className='homeExpertf16 homeExpertf31B'>
                                        {i18n.t('Freelance Marketplace')}
                                    </h5>
                                    <p className="homeExpertf35">
                                        {i18n.t('Profitez de la possibilité de publier gratuitement une offre ou d\'explorer notre CVthèque afin de trouver le profil idéal répondant parfaitement à vos besoins de prestation.')}
                                    </p>
                                </div>
                            </div>

                            <div className="homeExpertf33">
                                <DrawImageHomeEsn2321
                                    width={device=='desktop'?'446':'300'}
                                    height={device=='desktop'?'342':'100%'}
                                />
                                <div className='homeExpertf34'>
                                    <h5 className='homeExpertf16 homeExpertf31B'>
                                        {i18n.t('Vendor Management Solution')}
                                    </h5>
                                    <p className="homeExpertf35">
                                        {i18n.t('Nous vous offrons une assistance complète dans la gestion de vos ressources tout au long de vos prestations, couvrant la contractualisation, la gestion des Comptes Rendus d\'Activité, la facturation, et le suivi.')} </p>

                                </div>
                            </div>
                        </div>

                        <Button
                            onClick={()=>{
                                navigate('/pricing');
                            }}
                            style={{...buttonStylesBlue(false),width:device=='desktop'?'auto':'100%'}}
                        >
                            {i18n.t('Découvrez nos formules')}
                        </Button>

                    </div>

                    <div
                        className='homeExpertf1'
                        style={{width:'80%'}}
                    >
                        <div className="homeExpertf28">

                            <h3 className='homeExpertf19'>
                                {i18n.t('Comment ça marche')}
                            </h3>
                            <h5 className='homeExpertf16'>
                                {i18n.t('Vous avez déjà un projet et vous cherchez des ressources')}
                            </h5>
                        </div>
                        <div
                            className='homeExpertf10345343'
                            style={{alignSelf:'stretch'}}
                        >
                            <div className='homeExpertf36'>
                                <DrawImageHomeExpert21 />
                                <div className="homeExpertf37">
                                    <h6 className="homeExpertf38">
                                        {i18n.t('1. Recherchez un Expert')}
                                    </h6>
                                    <p className="homeExpertf35">
                                        {i18n.t('Publier une offre ou explorer notre CVTHèque')}
                                    </p>
                                </div>
                            </div>

                            <div className='homeExpertf36'>
                                <DrawImageHomeExpert22 />
                                <div className="homeExpertf37">
                                    <h6 className="homeExpertf38">
                                        {i18n.t('2. Get Matched')}
                                    </h6>
                                    <p className="homeExpertf35">
                                        {i18n.t('Trouvez le profil idéal qui match à votre projet')}
                                    </p>
                                </div>
                            </div>

                            <div className='homeExpertf36'>
                                <DrawImageHomeExpert23 />
                                <div className="homeExpertf37">
                                    <h6 className="homeExpertf38">
                                        {i18n.t('3. Contractualisez')}
                                    </h6>
                                    <p className="homeExpertf35">
                                        {i18n.t('Contractualisez avec les Experts retenus')}
                                    </p>
                                </div>
                            </div>

                            <div className='homeExpertf36'>
                                <DrawImageHomeExpert24 />
                                <div className="homeExpertf37">
                                    <h6 className="homeExpertf38">
                                        {i18n.t('4. Suivez vos projets')}
                                    </h6>
                                    <p className="homeExpertf35">
                                        {i18n.t('Gardez l\'œil sur vos projets et suivez-les')}
                                    </p>
                                </div>
                            </div>

                        </div>
                        {/*<div
                            className='homeExpertf1'
                            style={{flexDirection:'row',gap:'2%',alignSelf:'stretch'}}
                        >
                            <div className='homeExpertf36'>
                                <DrawImageHomeExpert21 />
                                <div className="homeExpertf37">
                                    <h6 className="homeExpertf38">
                                        1. Recherchez un Expert
                                    </h6>
                                    <p className="homeExpertf35">
                                        Publier une offre ou explorer notre CVTHèque
                                    </p>
                                </div>
                            </div>

                            <div className='homeExpertf36'>
                                <DrawImageHomeExpert22 />
                                <div className="homeExpertf37">
                                    <h6 className="homeExpertf38">
                                        2. Get Matched
                                    </h6>
                                    <p className="homeExpertf35">
                                        Trouvez le profil idéal qui match à votre projet
                                    </p>
                                </div>
                            </div>

                            <div className='homeExpertf36'>
                                <DrawImageHomeExpert23 />
                                <div className="homeExpertf37">
                                    <h6 className="homeExpertf38">
                                        3. Contractualisez
                                    </h6>
                                    <p className="homeExpertf35">
                                        Contractualisez avec les experts retenus
                                    </p>
                                </div>
                            </div>

                            <div className='homeExpertf36'>
                                <DrawImageHomeExpert24 />
                                <div className="homeExpertf37">
                                    <h6 className="homeExpertf38">
                                        4. Suivez vos projets
                                    </h6>
                                    <p className="homeExpertf35">
                                        Gardez l\'oeil sur vos projets et suivez les
                                    </p>
                                </div>
                            </div>

                        </div>*/}
                        <Button
                            style={{...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}}}
                            onClick={()=>{navigate('/register');}}
                        >{i18n.t('Nous Rejoindre')}</Button>

                    </div>

                    <div style={{width:'100%',display:'flex',alignItems:'center',gap:'79px',flexDirection:'column',paddingTop:'95px',justifyContent:'center',background: 'linear-gradient(180deg, #E7EAF9 0%, rgba(231, 234, 249, 0) 100%)'}}>
                        <div className="frame5HomePage">
                            <h3 className='homeExpertf19'>
                                <span style={{color:'#214DCE',display:'contents'}}>{i18n.t('High Tech Hires')}</span> {i18n.t('Vous Garantit')}
                            </h3>
                            <div
                                className="homeExpertf39"
                            >
                                {/*<div
                                    className="homeExpertf40"
                                    style={{
                                        display: 'grid',
                                        flex: '1 1 0%',
                                        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                                        background: '#F8F9FA',
                                        borderBottom: '1px solid #C3C9F1',
                                        height: 'fit-content',
                                        width:'100%',
                                    }}
                                >*/}
                                <div className='homeExpertf41'>
                                    <DrawImageHomeExpert25 />
                                    <h5 className="homeExpertf42">
                                        {i18n.t('Un processus simple')}
                                    </h5>
                                    <h6 className="homeExpertf43">
                                        {i18n.t('Profitez d\'un processus de sourcing "End to End" simple, efficace et complet, regroupant toutes les fonctionnalités sur une seule et même plateforme.')}
                                    </h6>
                                </div>

                                <div className='homeExpertf41'>
                                    <DrawImageHomeExpert25 />
                                    <h5 className="homeExpertf42">
                                        {i18n.t('Un accès rapide')}
                                    </h5>
                                    <h6 className="homeExpertf43">
                                        {i18n.t('Optimisez votre temps grâce à notre algorithme de matching performant qui vous permet de trouver rapidement les meilleurs experts pour vos projets.')}
                                    </h6>
                                </div>
                                {/*</div>*/}

                                {/*<div
                                    className="homeExpertf40"
                                    style={{
                                        display: 'grid',
                                        flex: '1 1 0%',
                                        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                                        background: '#F8F9FA',
                                        borderBottom: '1px solid #C3C9F1',
                                        height: 'fit-content',
                                        width:'100%',
                                    }}
                                >*/}
                                <div className='homeExpertf41'>
                                    <DrawImageHomeExpert25 />
                                    <h5 className="homeExpertf42">
                                        {i18n.t('Une mise en relation')}
                                    </h5>
                                    <h6 className="homeExpertf43">
                                        {i18n.t('High Tech Hires vous assure une mise en relation simple et directe entre les freelances et les ESN tout en protégeant les intérêts de chacun.')}
                                    </h6>
                                </div>

                                <div className='homeExpertf41'>
                                    <DrawImageHomeExpert25 />
                                    <h5 className="homeExpertf42">
                                        {i18n.t('Meilleur rapport qualité prix')}
                                    </h5>
                                    <h6 className="homeExpertf43">
                                        {i18n.t('Bénéficiez d\'un prix compétitif, équitable et aligné sur le marché pour un service de qualité exceptionnelle et sur mesure.')}
                                    </h6>
                                </div>
                                {/*</div>*/}
                            </div>
                            <Button
                                style={{...buttonStylesBlue(false),width:device=='desktop'?'auto':'100%'}}
                                onClick={()=>{
                                    navigate('/demo');
                                }}
                            >
                                {i18n.t('Demander une Démo')}
                            </Button>
                        </div>

                        {/*<div className='frame5HomePage'>
                            <div className='frame6HomePage'>
                                <h3 className='frame101HomePage'>
                                    <Trans>
                                        Nos Métiers
                                    </Trans>
                                </h3>
                            </div>

                            <div className='frame8HomePage'>
                                <div className='frame9HomePage'>
                                    <div className='frame10HomePage'>
                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox1container />
                                            </div>
                                            <p className='frame13HomePage'>
                                                Digital
                                            </p>
                                        </div>
                                        <p className='frame14HomePage'>
                                        Des développeurs, chefs de projets, scrums masters, et bien d&apos;autres, qui possèdent une expertise variée dans de multiples technologies et langages.
                                        </p>
                                    </div>
                                    <div className='frame10HomePage'>

                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox2container />
                                            </div>
                                            <p className='frame13HomePage'>
                                                Big Data
                                            </p>
                                        </div>
                                        <p className='frame14HomePage'>
                                            Des Experts Data Engineer, Data Analyst et bien d&apos;autres professionnels, tous dotés d&poa;une expertise approfondie dans l&apos;analyse et le traitement des données.
                                        </p>

                                    </div>
                                    <div className='frame10HomePage'>

                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox3container />
                                            </div>
                                            <p className='frame13HomePage'>
                                                DBA
                                            </p>
                                        </div>
                                        <p className='frame14HomePage'>
                                        Des DBAs hautement qualifiés qui possèdent une expertise solide dans la conception, la gestion, l&apos;optimisation et la sécurisation des bases de données.              </p>
                                    </div>

                                </div>

                                <div className='frame9HomePage'>

                                    <div className='frame10HomePage'>
                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox4container />
                                            </div>
                                            <p className='frame13HomePage'>
                                            SAP
                                            </p>
                                        </div>
                                        <p className='frame14HomePage'>
                                            Des expérimentés dans divers domaines, tels que MM, SD, FI, CO, PM, BW, etc., qui sont spécialisés dans toutes les solutions fournies par SAP.
                                        </p>
                                    </div>

                                    <div className='frame10HomePage'>

                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox5container />
                                            </div>
                                            <p className='frame13HomePage'>
                                            Cloud
                                            </p>
                                        </div>
                                        <p className='frame14HomePage'>
                                        Des spécialistes dans les domaines des infrastructures, de l&apos;hébergement, du stockage, de la sauvegarde de données, et bien d&apos;autres encore.
                                        </p>
                                    </div>

                                    <div className='frame10HomePage'>

                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox6container />
                                            </div>
                                            <p className='frame13HomePage'>
                                            ERP/CRM/SCM
                                            </p>
                                        </div>
                                        <p className='frame14HomePage'>
                                        Des consultants qualifiés qui possèdent une expertise dans Salesforces, Microsoft Dynamics, JDEdwards, Oracle, ainsi que dans d&apos;autres solutions et systèmes. .
                                        </p>

                                    </div>

                                </div>
                                <div className='frame9HomePage'>

                                    <div className='frame10HomePage'>
                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox7container />
                                            </div>
                                            <p className='frame13HomePage'>
                                            Sécurité des SI
                                            </p>
                                        </div>
                                        <p className='frame14HomePage'>
                                        Des spécialistes en cybersécurité, des administrateurs système et bien d&apos;autres professionnels possédant une expertise  dans la sécurité des systèmes.
                                        </p>
                                    </div>

                                    <div className='frame10HomePage'>

                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox8container />
                                            </div>
                                            <p className='frame13HomePage'>
                                            Devops
                                            </p>
                                        </div>
                                        <p className='frame14HomePage'>
                                        Des Experts DevOps possédant une expertise avérée dans l&apos;application des meilleures pratiques tout au long du cycle de vie d&apos;un projet.
                                        </p>

                                    </div>

                                    <div className='frame10HomePage'>

                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox9container />
                                            </div>
                                            <p className='frame13HomePage'>
                                            IA
                                            </p>
                                        </div>
                                        <p className='frame14HomePage'>
                                        Des développeurs IA, data miners, et bien d&apos;autres experts, ayant une expertise dans le développement, les tests et le déploiement des modèles d&apos;IA.                                        </p>

                                    </div>
                                </div>

                            </div>

                        </div>*/}
                        <div className='frame5HomePage'>
                            <div className='frame6HomePage'>
                                <h3 className='frame101HomePage'>
                                    <Trans>
                                        {i18n.t('Nos Métiers')}
                                    </Trans>
                                </h3>
                            </div>

                            <div className='frame8HomePage'>
                                <div className='frame9HomePage'>
                                    <div className='frame10HomePage'>
                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox1container />
                                            </div>
                                            <p className='frame13HomePage'>
                                                {i18n.t('Digital')}
                                            </p>
                                        </div>
                                        {device=='desktop' &&
                                        <p className='frame14HomePage'>
                                            {i18n.t('Des développeurs, chefs de projets, scrums masters, et bien d\'autres, qui possèdent une expertise variée dans de multiples technologies et langages.')}
                                        </p>
                                        }
                                    </div>
                                    <div className='frame10HomePage'>

                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox2container />
                                            </div>
                                            <p className='frame13HomePage'>
                                                {i18n.t('Big Data')}
                                            </p>
                                        </div>
                                        {device=='desktop' &&
                                        <p className='frame14HomePage'>
                                            {i18n.t('Des Experts Data Engineer, Data Analyst et bien d\'autres professionnels, tous dotés d\'une expertise approfondie dans l\'analyse et le traitement des données.')}
                                        </p>
                                        }

                                    </div>
                                    <div className='frame10HomePage'>

                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox3container />
                                            </div>
                                            <p className='frame13HomePage'>
                                                {i18n.t('DBA')}
                                            </p>
                                        </div>
                                        {device=='desktop' &&
                                        <p className='frame14HomePage'>
                                            {i18n.t('Des DBAs hautement qualifiés qui possèdent une expertise solide dans la conception, la gestion, l\'optimisation et la sécurisation des bases de données.')}
                                        </p>
                                        }

                                    </div>

                                    <div className='frame10HomePage'>
                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox4container />
                                            </div>
                                            <p className='frame13HomePage'>
                                                {i18n.t('SAP')}
                                            </p>
                                        </div>
                                        {device=='desktop' &&
                                        <p className='frame14HomePage'>
                                            {i18n.t('Des expérimentés dans divers domaines, tels que MM, SD, FI, CO, PM, BW, etc., qui sont spécialisés dans toutes les solutions fournies par SAP.')}                                              </p>
                                        }
                                    </div>

                                    <div className='frame10HomePage'>

                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox5container />
                                            </div>
                                            <p className='frame13HomePage'>
                                                {i18n.t('Cloud')}
                                            </p>
                                        </div>
                                        {device=='desktop' &&
                                        <p className='frame14HomePage'>
                                            {i18n.t('Des spécialistes dans les domaines des infrastructures, de l\'hébergement, du stockage, de la sauvegarde de données, et bien d\'autres encore.')}                                                </p>
                                        }

                                    </div>

                                    <div className='frame10HomePage'>

                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox6container />
                                            </div>
                                            <p className='frame13HomePage'>
                                                {i18n.t('ERP/CRM/SCM')}
                                            </p>
                                        </div>
                                        {device=='desktop' &&
                                        <p className='frame14HomePage'>
                                            {i18n.t('Des consultants qualifiés qui possèdent une expertise dans Salesforces, Microsoft Dynamics, JDEdwards, Oracle, ainsi que dans d\'autres solutions et systèmes.')}                                                 </p>
                                        }
                                    </div>

                                    <div className='frame10HomePage'>
                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox7container />
                                            </div>
                                            <p className='frame13HomePage'>
                                                {i18n.t('Sécurité des SI')}
                                            </p>
                                        </div>
                                        {device=='desktop' &&
                                        <p className='frame14HomePage'>
                                            {i18n.t('Des spécialistes en cybersécurité, des administrateurs système et bien d\'autres professionnels possédant une expertise dans la sécurité des systèmes.')}
                                        </p>
                                        }
                                    </div>

                                    <div className='frame10HomePage'>

                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox8container />
                                            </div>
                                            <p className='frame13HomePage'>
                                                {i18n.t('Devops')}
                                            </p>
                                        </div>
                                        {device=='desktop' &&
                                        <p className='frame14HomePage'>
                                            {i18n.t('Des Experts DevOps possédant une expertise avérée dans l\'application des meilleures pratiques tout au long du cycle de vie d\'un projet.')}
                                        </p>
                                        }

                                    </div>

                                    <div className='frame10HomePage'>

                                        <div className='frame11HomePage'>
                                            <div className='frame12HomePage'>
                                                <IconBox9container />
                                            </div>
                                            <p className='frame13HomePage'>
                                                {i18n.t('IA')}
                                            </p>
                                        </div>
                                        {device=='desktop' &&
                                        <p className='frame14HomePage'>
                                            {i18n.t('Des développeurs IA, data miners, et bien d\'autres experts, ayant une expertise dans le développement, les tests et le déploiement des modèles d\'IA.')}
                                        </p>
                                        }

                                    </div>
                                </div>

                            </div>
                            {/*<div className="frame19HomePage">
                                <Button
                                    variant="contained"
                                    sx={{height: 56}}
                                    //style={{
                                    //    backgroundColor: '#214DCE',
                                    //    borderRadius: '8px',
                                    //}}
                                    onClick={()=>{
                                        navigate('/login');
                                    }}
                                    style={{...buttonStylesBlue(),...{width:device=='desktop'?'auto':'100%'}
                                    }}
                                > Trouver un Expert</Button>
                            </div>*/}
                        </div>

                        <div className='homeExpertf44'>
                            <div className='homeExpertf45'>
                                <h3 className='frame101HomePage'>
                                    {i18n.t('Prêt à nous rejoindre et à adopter notre solution')}
                                </h3>
                                {device!='desktop' &&
                                <DrawImageHomeExpert26 />
                                }
                                <Button
                                    style={{...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}}}
                                    onClick={()=>{
                                        navigate('/register');
                                    }}
                                >
                                    {i18n.t('S\'inscrire')}
                                </Button>
                            </div>
                            {device=='desktop' &&
                            <DrawImageHomeExpert26 />
                            }
                        </div>
                    </div>

                </div>
                <Footer />
            </div>
        </>

    );
}

export default HomeESN;